let _ = require("ES/lib/lodash");
let dd = require("ES/lib/dd");
let Modal = require("ES/widgets/Modal");
let esUtils = require("ES/utils/esUtils");
let RadioMixin = require("ES/lib/react-pubsub-via-radio.js/RadioMixin");
let ErrorAlert = require("ES/widgets/ErrorAlert");
let RadioServiceMixin = require("ES/lib/react-pubsub-via-radio.js/RadioServiceMixin");
let LoadingWrap = require('ES/widgets/LoadingWrap');

let DaModal = dd.createClass({
	mixins: [RadioServiceMixin],
	RadioService_setup(){
		return {
			Event_update_children_reps: {
				key: "callService",
				on: {
					succeeded(){
						this.setState({
							children_updated: true
						});
					}
				}
			}
		};
	},
	__doIt: esUtils.wrapPreventDefault(function(){
		this.RadioService_callService("Event_update_children_reps", {
			eid: this.props.event.eid,
			pd_rep_id: this.props.event.pd_rep_id,
			sales_rep_id: this.props.event.sales_rep_id,
			project_manager_id: this.props.event.project_manager_id,
		});
	}),
	render(){
		let {event, onClose} = this.props;
		let ajax = this.state.Event_update_children_reps;
		let {children_updated} = this.state;

		let buttons = [{
			name: children_updated ? "Close" : "No thanks",
			onClick: onClose,
			className: "btn btn-default"
		}];
		if (!children_updated) {
			buttons.push({
				name: "Yes, please",
				onClick: this.__doIt,
				className: "btn btn-primary"
			});
		}

		let title = "Update children?";
		if (ajax.waiting) { title = "Updating children..."; }
		if (children_updated) { title = "Updated children."; }

		return Modal({
				title: title,
				buttons: (ajax.waiting ? [] : buttons),
				onClose
			},
			ErrorAlert({message: ajax.error}),
			LoadingWrap({is_loading: ajax.waiting, text: 'Updating internal team...'},
			(
				children_updated
					? dd.p(null,
							dd.b(null, _.size(_.filter(event.childevents, function(child) {
								return !((_.get(child, ["flags"], 0) & 4) > 0);
							}))),
							dd.span(null, " events have been updated.")
						)
					: dd.div(null,
							dd.p(null,
								"The team changed."
							),
							dd.p(null,
									"Would you like to update the internal team on open child events?"
							),
							dd.ul(null,
									_.map(_.filter(event.childevents, function(child) {
										return !((_.get(child, ["flags"], 0) & 4) > 0);
									}), function(child) {
										// filter events based on if they are still open
										return dd.li({key: child.id}, child.organization);
									})
							)
					)
			)
		));
	}
});

module.exports = dd.createClass({
	mixins: [RadioMixin],
	getInitialState(){
		return {event: null};
	},
	Radio_setup(){
		return {
			event_offer_to_update_children_reps(event){
				if(_.isEmpty(event && event.childevents)){
					return;
				}
				this.setState({event});
			}
		};
	},
	__close: esUtils.wrapPreventDefault(function(){
		this.setState({event: null});
	}),
	render(){
		let {event} = this.state;
		if(_.isEmpty(event && event.childevents)){
			return dd.span();
		}
		return DaModal({event, onClose: this.__close});
	}
});



// WEBPACK FOOTER //
// ./src/components/modals/PromptToChangeRepsForChildren.js